import { render, staticRenderFns } from "./user-renewal-new.vue?vue&type=template&id=6e81e5d9&"
import script from "./user-renewal-new.vue?vue&type=script&lang=js&"
export * from "./user-renewal-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports